import { Pipe, PipeTransform } from '@angular/core';
import { Util } from '../util';

@Pipe({
    name: 'vigencia'
})
export class BoolToVigenciaPipe implements PipeTransform {
    transform(isVigente: boolean) {
        return (isVigente) ? 'Vigente' : 'Encerrado';
    }
}

@Pipe({
    name: 'distribuicaoEquitativa'
})
export class BoolToDistribuicaoEquitativaPipe implements PipeTransform {
    transform(isDistribuicaoEquitativa: boolean) {
        return (isDistribuicaoEquitativa) ? 'Sim' : 'Não';
    }
}

@Pipe({
    name: 'sexo'
})
export class NumberToSexoPipe implements PipeTransform {
    transform(number: string) {
        return (number === '1') ? 'Feminino' : 'Masculino';
    }
}

@Pipe({
    name: 'unidadeFull'
})
export class UnidadeToUnidadeNameFullPipe implements PipeTransform {
    transform(unidade) {
        if (unidade == null) {
            return;
        }
        return unidade.tipologia + ' - ' + unidade.nomeUnidade + '/' + unidade.uf.siglaUf;
    }
}

@Pipe({
    name: 'enderecoFull'
})
export class EnderecoToEnderecoNameFullPipe implements PipeTransform {
    transform(endereco) {
        if (endereco == null) {
            return;
        }

        let uf = endereco.uf.siglaUf;
        if (Util.isNullOrEmptyOrUndefined(uf)) {
            uf = endereco.uf;
        }

        return endereco.logradouro + ', ' + endereco.complemento + '<br />'
            + endereco.bairro + ', ' + endereco.cidade + '/' + uf + '<br />'
            + Util.formatAsCep(endereco.cep);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/pipes/custom.pipe.ts